import React from 'react';
import { Layout, Card, Typography } from 'antd';
import blurBgImage from './blur-bg.webp';
import LanguageSwitcher from '../../components/language-switcher/language-switcher';

import './auth.scss';

const { Content } = Layout;
const { Title } = Typography;

interface AuthLayoutProps {
  title: string;
  children: React.ReactNode;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children, title }) => {
  return (
    <div
      className="auth-page"
      style={{
        backgroundImage: `url(${blurBgImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        width: '100vw',
        height: '100vh',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)', // Adjust opacity as needed (0.5 = 50% dark)
          backdropFilter: 'blur(5px)',
        }}
      />
      <Layout className="auth-layout">
        <Content className="auth-content">
          <Card className="auth-card">
            <Title level={2} className="auth-title">
              {title}
            </Title>
            {children}
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: '16px',
              }}
            >
              <LanguageSwitcher />
            </div>
          </Card>
        </Content>
      </Layout>
    </div>
  );
};

export default AuthLayout;
